import getBorderFocusStyles from '../../getBorderFocusStyles';
import getIconFillOrOutlineStyles from '../../getIconFillOrOutlineStyles';
var splitButtonStyles = {
  menuButton: function menuButton(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderRightWidth: 0,
      padding: v.padding
    }, p.size === 'small' && {
      height: v.smallDimension,
      padding: v.smallPadding,
      minWidth: v.smallMinWidth,
      boxShadow: v.smallBoxShadow
    }, {
      ':focus-visible': {
        borderRightWidth: 0,
        ':before': {
          borderRightWidth: 0
        },
        ':after': {
          borderRightWidth: 0
        }
      },
      ':active': {
        animationName: 'unset',
        animationDuration: 'unset'
      }
    });
  },
  toggleButton: function toggleButton(_ref2) {
    var p = _ref2.props,
        v = _ref2.variables,
        siteVariables = _ref2.theme.siteVariables;
    return Object.assign({
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderColor: v.borderColor
    }, getIconFillOrOutlineStyles({
      outline: true
    }), {}, p.primary && {
      borderWidth: "0 0 0 ".concat(siteVariables.borderWidth),
      borderColor: v.borderColorPrimary
    }, {}, p.disabled && {
      borderWidth: "0 0 0 ".concat(siteVariables.borderWidth),
      borderColor: v.borderColorDisabled
    }, {}, p.size === 'small' && {
      height: v.smallDimension,
      width: v.smallDimension,
      minWidth: v.smallMinWidth,
      boxShadow: v.smallBoxShadow
    }, {
      ':focus-visible': {
        ':before': {
          borderLeftWidth: 0
        },
        ':after': {
          borderLeftWidth: 0
        }
      },
      ':active': {
        animationName: 'unset',
        animationDuration: 'unset'
      }
    });
  },
  root: function root(_ref3) {
    var p = _ref3.props,
        v = _ref3.variables,
        siteVariables = _ref3.theme.siteVariables;
    var borderFocusStyles = getBorderFocusStyles({
      siteVariables: siteVariables
    });
    return {
      borderRadius: v.borderRadius,
      position: 'relative',
      display: 'inline-block',
      ':focus-within': Object.assign({
        boxShadow: 'none'
      }, p.isFromKeyboard && Object.assign({}, borderFocusStyles[':focus-visible']))
    };
  }
};
export default splitButtonStyles;